var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "EarlyAccess",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-early-access","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M56 238.7C25.4 238.7.5 213.8.5 183.2s24.9-55.5 55.5-55.5c12.5 0 24.3 4.1 34.1 11.8l.7.6L221 9.1l7.6 7.6-16.4 16.5L250 71.6l-7.7 7.5-37.7-38.4-19.3 19.5L223 98.7l-7.7 7.5-37.6-38.3-79.2 79.6.6.7c8 9.9 12.4 22.3 12.4 34.9 0 30.7-24.9 55.6-55.5 55.6zm0-100.3c-24.7 0-44.7 20.1-44.7 44.7s20.1 44.7 44.7 44.7 44.7-20.1 44.7-44.7-20.1-44.7-44.7-44.7z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/early-access.svg